/**
 * useIsBody React custom hook
 * Usage:
 *    const { isBody } = useIsBody();
 */
import { useState, useEffect } from 'react';

import { IS_BROWSER } from '@wconcept/wconcept-common/utils/baseUtils';

const useIsBody = () => {
  const [isBody, setBody] = useState<HTMLElement>();

  useEffect(() => {
    const chk = window.setInterval(() => {
      if (IS_BROWSER && document.body) {
        window.clearInterval(chk);
        setBody(document.body);
      }
    }, 500);

    return () => {
      if (chk) window.clearInterval(chk);
    };
  }, []);

  return { isBody };
};

export default useIsBody;
